import script from "./AvailabilitySLA.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailabilitySLA.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__